const dataCampus = [
    {
        id:0,
        name:"Anáhuac México Norte",
        alias:"UAMN",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_01_norte-jrmjxf.jpg",
        web:"https://www.anahuac.mx/mexico/posgrados/",
    },
    {
        id:1,
        name:"Anáhuac México Sur",
        alias:"UAMS",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_03_sur-c3lax2.jpg",
        web:"https://www.anahuac.mx/mexico/posgrados/",
    },
    {
        id:2,
        name:"Anáhuac IEST",
        alias:"IEST",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_02_iest-49hhgr.jpg",
        web:"https://www.anahuac.mx/iest/posgrado",
    },
    {
        id:3,
        name:"Anáhuac Mérida",
        alias:"UAM",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_04_mayab-ldf4hc.jpg",
        web:"https://merida.anahuac.mx/posgrado",
    },
    {
        id:4,
        name:"Anáhuac Veracruz Campus Xalapa",
        alias:"UAX",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_05_jalapa-yq8p9e.jpg",
        web:"https://www.anahuac.mx/veracruz/posgrados-y-extension",
    },
    {
        id:5,
        name:"Anáhuac Veracruz Campus Córdoba - Orizaba",
        alias:"UACO",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/Campus_cordoba_veracruz-ttyful.png",
        web:"https://www.anahuac.mx/veracruz/posgrados-y-extension",
    },
    {
        id:6,
        name:"Anáhuac Cancún",
        alias:"UAC",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/anahuac_cancun_1-g1u9yl.jpg",
        web:"https://www.anahuac.mx/cancun/posgrados-y-extension",
    },
    {
        id:7,
        name:"Anáhuac Oaxaca",
        alias:"UAO",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_07_oaxaca-911iu2.jpg",
        web:"https://oaxaca.anahuac.mx/posgrados",
    },
    {
        id:8,
        name:"Anáhuac Puebla",
        alias:"UAP",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_08_puebla-wsjww2.jpg",
        web:"https://puebla.anahuac.mx/posgrados"
    },
    {
        id:9,
        name:"Anáhuac Querétaro",
        alias:"UAQ",
        image:"https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_09_queretaro-llpbk1.jpg",
        web:"https://queretaro.anahuac.mx/posgrados"
    },{
        id: 10,
        name: "Anáhuac Online",
        alias: "UAON",
        image: "https://www.anahuac.mx/sites/default/files/gbb-uploads/Logo_800x525px_WebAnahuac_Online-dbr8e6.jpg",
        web: "https://online.anahuac.mx/maestrias-en-linea/"
    },
    {
        id: 11,
        name: "Pontificio Instituto Juan Pablo II",
        alias: "IJPII",
        image: "https://www.anahuac.mx/sites/default/files/gbb-uploads/univ_10_juanpablo-uj4jj8.jpg",
        web: "https://familia.anahuac.mx/oferta-educativa/",
       
    }
        
]
export default dataCampus;